<template>
  <div class="flex flex-col gap-2 mt-4 px-4">
    <div
      v-if="flagsHistory.length == 0"
      class="bg-red-600 text-white p-4 rounded-md"
    >
      No flags registered
    </div>
    <div v-else>
      <div
        v-for="flag in flagsHistory"
        :key="flag.uuid"
        class="bg-gray-300 p-2 rounded-md"
      >
        <p class="flex flex-row">
          <b
            ><button @click="openOrder(flag.orderUuid)">
              {{ flag.orderNumber }}
            </button>
            - {{ flag.name }} ({{ flag.createdAt | dateWithHours }})</b
          >
          <span v-if="flag.flag == 1">
            <img
              class="w-4 h-4 ml-4 flex-shrink-0"
              src="img/api/menu-icons/flag.svg"
              alt="flag"
            />
          </span>
          <span v-else>
            <img
              class="w-4 h-4 ml-4 flex-shrink-0"
              src="img/api/menu-icons/flag-green.svg"
              alt="flag"
            />
          </span>
        </p>
        <p>{{ flag.comment }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseFlagsHistory",
  computed: {
    flagsHistory() {
      return this.$store.getters["general/getFlagsHistory"];
    }
  },
  methods: {
    openOrder(orderUuid) {
      this.$emit("openOrder", orderUuid);
    }
  }
};
</script>
